import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../store/store';
import { initializeAuth } from '../store/slices/authSlice';
import { supabase } from '../services/supabase';

// This component handles initializing authentication and setting up auth state listeners
const AuthInitializer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    // Initialize auth state on load
    dispatch(initializeAuth());

    // Set up auth state listener to update whenever auth changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      // Reinitialize auth when session changes
      dispatch(initializeAuth());
    });

    // Cleanup subscription on unmount
    return () => {
      subscription.unsubscribe();
    };
  }, [dispatch]);

  return <>{children}</>;
};

export default AuthInitializer; 